module.exports = __webpack_public_path__ + "static/media/ic-unverified-location-large.63cca472.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-unverified-location-large.svg
// module id = 788
// module chunks = 0